<template>
  <div class="footer-wrapper">
    <div class="footer-toggle" @click="toggleVisibility">
      <div class="arrow" :class="{ 'arrow-expanded': isVisible }"></div>
    </div>
    <el-footer class="footer" :class="{ 'footer-collapsed': !isVisible }">
      <div class="footer-content" v-if="isVisible">
        <div class="footer-info">
          <span class="copyright">运维练兵场 © Since 2019</span>
          <span class="icp">陕ICP备20006263号</span>
        </div>
        <div class="footer-links">
          <el-link type="primary" href="/about-us">关于我们</el-link>
          <el-link type="primary" href="/faq">常见问题</el-link>
          <el-link type="primary" href="/privacy">隐私政策</el-link>
          <el-link type="primary" href="/status"><span class="status-link-dot"></span>服务状态</el-link>
          <el-link type="primary" href="/contact">联系我们</el-link>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "FooterView",
  setup() {
    const isVisible = ref(true);

    const toggleVisibility = () => {
      isVisible.value = !isVisible.value;
    };

    return {
      isVisible,
      toggleVisibility,
    };
  },
};
</script>

<style scoped>
.footer-wrapper {
  position: relative;
  width: 100%;
  background-color: #f5f7fa;
}

/* 折叠按钮 */
.footer-toggle {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dcdfe6;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
}

.footer-toggle:hover {
  background-color: #c0c4cc;
  transform: scale(1.05);
}

.arrow {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid #ffffff;
  transition: transform 0.3s ease;
}

.arrow-expanded {
  transform: rotate(90deg);
}

/* Footer 主体 */
.footer {
  background-color: #f5f7fa;
  border-top: 1px solid #e4e7ed;
  padding: 20px 24px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.footer-collapsed {
  padding: 8px 24px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
}

/* 左侧版权信息 */
.footer-info {
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 13px;
  color: #909399;
}

.copyright {
  color: #606266;
}

.icp {
  color: #909399;
}

.icp:hover {
  color: #409eff;
  cursor: pointer;
}

/* 右侧链接区域 */
.footer-links {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-links :deep(.el-link) {
  font-size: 13px;
  color: #606266;
}

.footer-links :deep(.el-link:hover) {
  color: #409eff;
}

.status-link-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 6px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, .12);
}

/* 响应式布局 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .footer-info {
    flex-direction: column;
    gap: 8px;
  }

  .footer-links {
    justify-content: center;
    gap: 16px;
  }

  .footer-toggle {
    right: 12px;
    bottom: 12px;
    width: 28px;
    height: 28px;
  }

  .arrow {
    border-left: 6px solid #ffffff;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
  }
}
</style>
